import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SearchCampaigns } from 'generated/graphql';

@Component({
  selector: 'app-campaign-select2',
  templateUrl: './campaign-select2.component.html',
})
export class CampaignSelect2Component {
  expanded = false;
  @Input() selectedItem: { id: string; name: string };
  @Output() selectedItemChange = new EventEmitter<{ id: string; name: string }>();
  /** optional filter function to filter visible results */
  @Input() resultsFilterFn: (node: SearchCampaigns.Node) => boolean;
  @Input() buttonClass: string;

  /**
   *
   */
  constructor(
    private cd: ChangeDetectorRef,
  ) {
  }

  onQuickSearchItemSelected(item: any) {
    this.selectedItemChange.emit(item);
    this.expanded = false;
    this.cd.markForCheck();
  }

  expand() {
    this.expanded = true;
    this.cd.markForCheck();
  }
}
